import Link from 'next/link';

/**
 * Tag component for Blurb - usually displayed over the image.
 */
export default function BlurbTag({ href = '', children, className = '' }) {
  if (!children) return null;

  return href ? (
    <Link href={href}>
      <span className={`Blurb__tag ${className}`}>{children}</span>
    </Link>
  ) : (
    <span className={`Blurb__tag ${className}`}>{children}</span>
  );
}
